import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/Kpi";

/** Scelta della pagina di apertura dell'app (visibile solo se il MASTER la consente). */
export function PaginaIniziale() {
  const { setUser } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/auth/pagina-iniziale").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d?.consentito) return null;

  const salva = async (pagina) => {
    try {
      const { data } = await api.put("/auth/pagina-iniziale", { pagina: pagina || null });
      setUser(data);
      setD({ ...d, pagina: pagina || null });
      toast.success(pagina ? "Pagina iniziale salvata" : "Ripristinata la pagina predefinita");
    } catch (e) { toast.error(apiError(e)); }
  };
  const gruppi = [["lungo", "Canale lungo"], ["corto", "Canale corto"], ["globale", "Trasversali"]]
    .map(([k, label]) => [label, d.opzioni.filter((o) => o.canale === k)]).filter(([, o]) => o.length);

  return (
    <Card className="p-6" data-testid="account-pagina-iniziale">
      <div className="text-xs uppercase tracking-[0.18em] font-semibold text-slate-500 mb-1">Pagina iniziale</div>
      <div className="text-sm text-slate-600 mb-4">
        La pagina che si apre all'avvio dell'app o del sito, saltando la scelta del canale.
      </div>
      <select value={d.pagina || ""} onChange={(e) => salva(e.target.value)} data-testid="pagina-iniziale-select"
        className="w-full border border-slate-300 rounded-md px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-sky-300">
        <option value="">Predefinita (scelta del canale)</option>
        {gruppi.map(([label, opzioni]) => (
          <optgroup key={label} label={label}>
            {opzioni.map((o) => <option key={o.path} value={o.path}>{o.label}</option>)}
          </optgroup>
        ))}
      </select>
    </Card>
  );
}
